// Constants
import * as Constants from "../../constants";

// Helpers
import DB from "../../helpers/db";

import { SIGNOUT, LOADER } from "../definitions";
import { startloader, endloader } from "./loginAction";
import SystemAlert from "../../components/SystemAlert";

export const fetchSignOut = (props) => async (dispatch) => {
  try {
    dispatch({
      type: SIGNOUT.SIGNOUT_START_FETCH,
    });
    dispatch(startloader());

    // First API call: /signout to clear all cookies
    const signoutResponse = await DB({
      method: Constants.HTTP_GET,
      url: `/signout`,
      withCredentials: true, // to include cookies in request headers
    });

    if (signoutResponse?.data?.statusCode === "0") {
      // Second API call: /isdeleted to check if cookies are deleted
      const isDeletedResponse = await DB({
        method: Constants.HTTP_GET,
        url: `/isdeleted`,
        withCredentials: true, // to include cookies in request headers
      });
      if (isDeletedResponse?.data?.statusCode === "0") {
        // Second action: Redirect to the SSO logout URL
        const signouturl = Constants.entitiesSignoutOriginObject[window.location.origin];
        window.location.href = signouturl; // Redirect to sso logout

        // Dispatch action to indicate signout finish
        dispatch({
          type: SIGNOUT.SIGNOUT_FINISH_FETCH,
          payload: isDeletedResponse.data,
        });
      } else {
        SystemAlert.error("You are not authorized to perform this operation");
      }
    }  else {
        SystemAlert.error("You are not authorized to perform this operation");
    }

    dispatch(endloader());
  } catch (error) {
    console.error(error);
    dispatch({
      type: SIGNOUT.SIGNOUT_FAIL_FETCH,
      payload: error,
    });
    dispatch({
      type: LOADER.END_LOADER,
      payload: false,
    });
  } finally {
    dispatch({
      type: LOADER.END_LOADER,
      payload: false,
    });
  }
};
